export enum UserTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
  ASSOCIATION = 'ASSOCIATION',
}
